import React, { useRef } from "react";

import { mdiChevronDown } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";

import Dropdown from "../../dropdown/Dropdown";

import type { DropdownRef } from "../../dropdown/Dropdown";

type VttType = "subtitles" | "chapters";

interface CardVttBadgeProps {
  type: VttType;
  onTypeChange: (type: VttType) => void;
}

export default function CardVttBadge({
  type,
  onTypeChange,
}: CardVttBadgeProps): React.JSX.Element {
  const { t } = useTranslation("editor-content");
  const triggerRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<DropdownRef>(null);

  const dropdownItems = ["subtitles" as const, "chapters" as const].map(
    (item) => ({
      value: item,
      label: (
        <div className="text-muted-foreground hover:bg-muted flex w-full items-center justify-between gap-4 px-3.75 py-1.75">
          {t(item)}
        </div>
      ),
    }),
  );

  return (
    <div className="relative">
      <div
        ref={triggerRef}
        className="bg-muted text-muted-foreground hover:bg-muted flex cursor-pointer items-center rounded px-1 py-0.5 text-[0.78125rem] font-medium"
        onClick={() => dropdownRef.current?.toggle()}
      >
        {t(type)} <Icon path={mdiChevronDown} size={0.625} />
      </div>
      <Dropdown
        ref={dropdownRef}
        withoutChevron
        withoutTrigger
        externalRef={triggerRef as React.RefObject<HTMLDivElement>}
        items={dropdownItems}
        maxHeight={300}
        onClick={onTypeChange}
      />
    </div>
  );
}
